import {
  MDBAlert,
  MDBCol,
  MDBDatatable, MDBRow,
  MDBScrollspy,
  MDBScrollspyLink
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";

import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import {
  getAccountLevelBlfGroups,
  getBlfConfiguredDevices,
  getDeviceOnlineStatusInfo,
  updateBlfGroupName,
} from "../../../apiclients/streamsapi_bridge";
import SaveChanges from "../saveCancel";

export default function BlfSettings(props) {
  console.log("BlfSettings props=======> : " + JSON.stringify(props));
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const section1 = useRef(null);
  const section2 = useRef(null);
  const [updatedBlfGroupInfo, setupdatedBlfGroupInfo] = useState({});
  const [accountBlfGroups, setAccountBlfGroups] = useState([]);
  const [existedgroupname, setExistedgroupname] = useState(false);
  const containerRef = useRef(null);
  const [blfConfigDevices, setBlfConfigDevices] = useState([]);
  // React Hook form
  const {
    register,
    reset,
    watch,
    formState: { dirtyFields, isDirty, errors },
    handleSubmit,
    setError,
  } = useForm();
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();

  console.log("props data :" + JSON.stringify(props.groupInfo));
  useEffect(() => {
    fetchAccountLevelBlfGroups();
    console.log("element satate");
    fetchBlfConfiguredDevices();
    reset(props.groupInfo);
  }, []);

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  const fetchAccountLevelBlfGroups = async () => {
    try {
      console.log("[fetchAccountLevelBlfGroups] :");
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      let apiResponse = await getAccountLevelBlfGroups(siteid);
      console.dir(apiResponse);
      if (!apiResponse.ok) {
        console.log(
          "got an issue in fetchAccountLevelBlfGroups with node server "
        );
        throw new Error("Network response was not ok");
      } else {
        let responseData = await apiResponse.json();
        let blfgroupdata =
          await responseData.blfGroupsList; /*  [{"id":2,"group_name":"Ganesh","site_id":3628},{"id":3,"group_name":"yella","site_id":3628},{"id":4,"group_name":"Nagoor","site_id":3628}] */
        console.log(
          "[fetchAccountLevelBlfGroups] Blfs Groups data from node server :" +
          JSON.stringify(blfgroupdata)
        );
        if (blfgroupdata.length > 0) {
          console.log("blfgroupdata ::::::::: " + JSON.stringify(blfgroupdata));
          setAccountBlfGroups(blfgroupdata);
        } else {
          console.log("No BLF groups found for site ID :" + siteid);
        }
      }
    } catch (e) {
      console.error("[fetchAccountLevelBlfGroups] Error : " + e);
    }
  };

  const fetchBlfConfiguredDevices = async () => {
    try {
      console.log("[fetchBlfConfiguredDevices] :");
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      let params = {
        blf_group_id: props.groupInfo.groupid,
      };
      let apiResponse = await getBlfConfiguredDevices(params, siteid);
      console.dir(apiResponse);
      if (!apiResponse.ok) {
        console.log(
          "got an issue in fetchBlfConfiguredDevices with node server "
        );
        throw new Error("Network response was not ok");
      } else {
        let responseData = await apiResponse.json();
        let blfConfigDevices = await responseData.blf_config_devices;
        console.log(
          "blfConfigDevices ::::::::: " + JSON.stringify(blfConfigDevices)
        );
        var devises = [];
        if (blfConfigDevices.length > 0) {
          blfConfigDevices.forEach((device) => {
            let recordJo = {};
            recordJo.phone_name = device?.phone_name;
            recordJo.user = device?.user;
            recordJo.extension = device?.extension;
            recordJo.model = device?.model;
            recordJo.macAdress = device?.macaddress;
            recordJo.configuration = (device?.configuration == 1 ? <span className="red-dot"></span> : <span className="green-dot"></span>); recordJo.online = <span className="red-dot"></span>;
            devises.push(recordJo);
          });
          setBlfConfigDevices(devises);
        } else {
          console.log("No BLF configured devices found for group :" + siteid);
        }

        let macAddresses = devises.map((obj) => obj.macAdress);
        console.log(" configDevices macAddresses :: ", macAddresses);
        var paramsJo = {
          macAddresList: macAddresses,
        };
        console.log("praramJO:::::::::" + JSON.stringify(paramsJo));
        let api_response = await getDeviceOnlineStatusInfo(
          JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          paramsJo
        );
        let response = await api_response.json();
        var livedataObjectsInfo = response.deviceStatus;
        if (!api_response.ok) {
          // console.log("Server response was not ok");
          // throw new Error("Network response was not ok");
        }
        console.log(
          "livedataObjectsInfo ::: " + JSON.stringify(livedataObjectsInfo)
        );

        let configured_devices_withstatus = [];
        for (const data of devises) {
          let result = livedataObjectsInfo.find(
            (liveobj) => data?.macAdress == liveobj?.macaddress
          );
          data.online = result?.online_status ? (
            <span className="green-dot"></span>
          ) : (
            <span className="red-dot"></span>
          );
          configured_devices_withstatus.push(data);
        }
        setBlfConfigDevices(configured_devices_withstatus);
      }
    } catch (e) {
      console.error("[fetchAccountLevelBlfGroups] Error : " + e);
    }
  };

  console.log("props :dcs   " + JSON.stringify(props));

  const configuredDevices = {
    columns: [
      { label: "Phone Name", field: "phone_name" },
      { label: "User", field: "user" },
      { label: "Extension", field: "extension" },
      { label: "Model", field: "model" },
      { label: "MAC Address", field: "macAdress" },
      { label: "Configuration Update", field: "configuration" },
      { label: "Online", field: "online", sort: false },
    ],
    rows: blfConfigDevices,
  };

  const onCloseChanges = () => {
    setExistedgroupname(false);
    reset();
  };
  useEffect(() => {
    props.setFieldEdited(isDirty);

  }, [isDirty])

  const onsaveChanges = (formdata) => {
    console.log(
      "accountBlfGroups :::: " + JSON.stringify(props.accountBlfGroups)
    );
    var groupnames = [];
    accountBlfGroups.forEach((groups) => {
      groupnames.push(groups.group_name);
    });
    var exist = groupnames.includes(formdata.groupname);
    setExistedgroupname(exist);
    if (exist) {
      return;
    }
    try {
      console.log(
        "[BLFSettings.js] Making server request to submit " +
        JSON.stringify(formdata)
      );
      if (isDirty) {
        console.log("Making server request ");
        let reqpramsjo = {};
        reqpramsjo.groupid = formdata.groupid;
        reqpramsjo.group_name = formdata.groupname;
        editBlfGroupname(reqpramsjo, formdata);
      }
    } catch (e) {
      console.error("[BLFSettings.js] Error while making server request " + e);
    }
  };
  props.setIsEdited(isDirty);
  const [reloadSettings, setReloadSettings] = useState(false);
  const editBlfGroupname = async (reqpramsjo, formdata) => {
    try {
      reqpramsjo.reqid = 44;
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      let serverResponse = await updateBlfGroupName(siteid, reqpramsjo);
      if (!serverResponse.ok) {
        console.log("Network Error ");
      } else {
        console.log("editBlfGroupname Resoponce is succesfull");
        console.log(serverResponse.json());
        setupdatedBlfGroupInfo(formdata);
        setReloadSettings(true);
        setSuccessMessage(`BLF Group Name successfully updated.`);
        props.groupInfo.groupname = formdata.groupname;
        //navigator()
        reset(formdata);
      }
    } catch (e) {
      console.log("error in editBlfGroupname : " + e);
    }
  };

  const redirectToSettings = (row) => {
    console.log("[redirectToSettings] :" + JSON.stringify(row));
    try {
      if (row && row.macAdress != "") {
        navigate("/ipphoneadd", {
          state: { macAdress: row.macAdress, device:JSON.stringify({})},
        });
      }
    } catch (e) {
      console.log("error in RedirectToSettings :" + e);
    }
  };




  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const scrollspyLinks = document.querySelectorAll('.sticky-top .nav-link');
      const lastLink = scrollspyLinks[scrollspyLinks.length - 1];

      if (lastLink.classList.contains('active')) {
        lastLink.classList.remove('active');

        const firstLink = scrollspyLinks[0];
        if (firstLink) {
          firstLink.classList.add('active');
        }
      }
    }, 100);

    return () => clearTimeout(timeoutId);
  }, []);




  return (
    <React.Fragment>
      <>
        <MDBRow>
          <MDBCol
            size="2"
            md="2"
            lg="2"
            sm="12"
            className="col-sm-100 pr-0 leftTabs"
          >
            {/* 
                                <MDBTabs className="flex-column text-center">
                                  <MDBTabsItem>
                                    <MDBTabsLink
                                      className=""
                                      onClick={() => handleVerticalClick("tab1")}
                                      active={verticalActive === "tab1"}
                                    >
                                      {t("general")}

                                      {t("configuredDevices")}
                                    </MDBTabsLink>
                                  </MDBTabsItem>
                                </MDBTabs> */}

            <MDBScrollspy container={containerRef} offset={600}>
              <MDBScrollspyLink targetRef={section1}>
                {t("general")}
              </MDBScrollspyLink>
              <MDBScrollspyLink targetRef={section2}>
                {" "}
                {t("configuredDevices")}
              </MDBScrollspyLink>
            </MDBScrollspy>
          </MDBCol>

          <MDBCol
            size="12"
            md="10"
            sm="12"
            pr-0
            className="col-sm-100 pr-0 leftTabContent"
          >
            <div id="element" ref={containerRef} className="scrollspy-example">
              <div className="vtabHeight pb-3">
                <section ref={section1} id="section-1">
                  <h5 className="fw-600">{t("general")} </h5>
                  <div className="d-flex justify-content-between align-items-center mt-4">
                    <div>{t("BLFGroupName")}</div>
                    <div>
                      <input
                        type="text"
                        className="form-control selectname w-100"
                        maxLength={30}
                        onKeyDown={(event) => {
                          if (!/[a-zA-Z0-9 _]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        {...register(`groupname`, { required: true })}
                      />
                      {errors.groupname && <p className="text-danger">BLF Group Name should not be empty</p>}
                    </div>
                  </div>
                  <div className="float-end">
                    {existedgroupname && (
                      <span className="red mb-1">
                        The BLF Group Name entered already exists, please try a
                        different name.
                      </span>
                    )}
                  </div>
                </section>
                <div className="routing-border"></div>
                <section ref={section2} id="section-2">
                  <h5 className="fw-600">{t("configuredDevices")} </h5>
                  <div>
                    <MDBDatatable
                      sortField="Phone Name"
                      data={configuredDevices}
                      pagination={false}
                      onRowClick={(row) => redirectToSettings(row)}
                      style={
                        { minHeight: "50vh" }
                      }
                    />
                  </div>
                </section>
              </div>
            </div>
            {successMessage && (
              <MDBAlert
                open
                className="alert-center"
                color="success"
                autohide
                position="bottom-right"
                delay={10000}
              >
                <i className="fas fa-check-circle me-3"></i>
                <span className="alert-msg">{successMessage}</span>
              </MDBAlert>
            )}
          </MDBCol>
        </MDBRow>
        {/* {reloadSettings && console.log("reloading:::::::::::::::::") && <BlfSettings groupInfo={updatedBlfGroupInfo} />} */}
        {isDirty && (
          <SaveChanges
            onClose={onCloseChanges}
            onSave={(e) => {
              handleSubmit(onsaveChanges)();
            }}
          />
        )}
      </>
    </React.Fragment>
  );
}
